import type { OrgModelPermissionMode } from '@nadoutong/contracts';
import type { I18nKey } from '../../i18n/index.ts';
import type { ChipTone } from '../../ui/index.ts';

/**
 * How a model-permission mode reads in the UI.
 *
 * Shared by the permissions tab (which owns the mode) and the member
 * directory row (which only reports it), so the two can never drift
 * into calling the same mode by different names or colours.
 */
export function modelPermissionModeLabelKey(mode: OrgModelPermissionMode): I18nKey {
  if (mode === 'all') return 'organization.permissions.mode.all';
  if (mode === 'custom') return 'organization.permissions.mode.custom';
  return 'organization.permissions.mode.inherit';
}

/**
 * `custom` reads as an operator-authored exception, so it takes the rust
 * accent — Field Notes has no `signal` tone, which is what the source
 * page used here.
 */
export function modelPermissionModeTone(mode: OrgModelPermissionMode): ChipTone {
  if (mode === 'all') return 'ok';
  if (mode === 'custom') return 'rust';
  return 'neutral';
}
